export const COLORS = {
    $primaryBackground: '#FFEEEE',
    $infoBackground: '#E6F7FF',
    $tartRedBackground: '#FFEBEB',
    $tartRed: '#F25858'
};
